import { MatDialog } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_service/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertifyService } from '../_service/alertify.service';
import { LoginComponent } from '../login/login.component';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'resetPassword',
  templateUrl: './resetPassword.component.html',
  styleUrls: ['./resetPassword.component.css']
})
export class ResetPasswordComponent implements OnInit {
  hide = true;
  model: any = {};
  code: any;
  email: any;
  passwordResetResponse: any = {};
  passwordResetError: any = {};
  isLoading = false;

  resetPasswordForm: FormGroup;

  constructor(
    public authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private alertify: AlertifyService,
    private dialog: MatDialog,
    public fb: FormBuilder
  ) 
  {
    this.resetPasswordForm = fb.group({
      emailFormControl : new FormControl('', []).clearValidators(),

      passwordFormControl:  new FormControl('', [
        Validators.required,
        this.WhitespaceValidator,
        Validators.minLength(6),
        Validators.maxLength(20),
        // required: combination of letters and numbers
        // optional: characters, capital letters
        Validators.pattern('^(?=[^a-z]*[a-z])(?=.*[0-9])(?=[^A-Z]*[A-Za-z]).{6,20}$')
      ]),

      confirmPasswordFormControl:  new FormControl('', [
        Validators.required,
        this.WhitespaceValidator
      ]),
    }, {
      validators: this.MustMatch('passwordFormControl', 'confirmPasswordFormControl')
    });
  }

  ngOnInit() {
    this.email = this.route.snapshot.queryParams.email;
  }

  
  public MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }
        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}

   loginPrompt() {
            const dialogRef = this.dialog.open(LoginComponent, {
              width: '500px'
            });
          }

  resetPassword() {
    this.model.password = this.resetPasswordForm.get('passwordFormControl').value.trim();
    this.model.confirmPassword =  this.resetPasswordForm.get('confirmPasswordFormControl').value.trim();

   if (this.model.password === this.model.confirmPassword) {

    this.model.email = this.route.snapshot.queryParams.email;
    this.model.code = this.route.snapshot.queryParams.code;

    this.isLoading = true;

    return this.authService.resetPassword(this.model).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.passwordResetError = res.headers.get('reseterror');
        if (this.passwordResetError) {
          this.alertify.message(this.passwordResetError);
          this.router.navigate(['/search']);
        }
        this.passwordResetResponse = res.headers.get('passwordreset');
        if (this.passwordResetResponse) {
          this.alertify.success(this.passwordResetResponse);
          this.router.navigate(['/search']);
          this.loginPrompt();
        }
      },
      error => {
        this.isLoading = false;
        this.alertify.error('Something went wrong!');
      }
    );
 } else {
  this.alertify.error('Passwords do not match');
}
}
}